// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2416) return "static/chunks/2416-1d6c2957a0fb6306.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2349":"94eabb79b9f5939e","2913":"23e952dd3d269348","9961":"c2562950cf21826a"}[chunkId] + ".js";
};